









import Vue from 'vue';

export default Vue.extend({
  props: {
    url: {
      type: String,
      required: true,
    },
  },
  computed: {
    parsedUrl(): string {
      const regex = new RegExp('^(https?:\\/\\/)');
      if (this.url.match(regex) === null) return this.url;
      return this.url.replace(regex, '//');
    },
  },
});
